import { render, staticRenderFns } from "./BridgeFile.vue?vue&type=template&id=a480782a&"
import script from "./BridgeFile.vue?vue&type=script&lang=js&"
export * from "./BridgeFile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports